module.exports = __webpack_public_path__ + "img/filter-list-24px.4e9f1abd.png";